export default __webpack_public_path__ + "media/Copy.64511e39.svg";